(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('LensApp', LensApp);

    /* @ngInject */
    function LensApp($resource) {
        var resourceUrl = 'api/lens-apps/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
